import React, { Component } from 'react';

export class Contact extends Component {
    render() {
        return (
            <div className="contacts">
                <div data-form-id='bb4c62ed-40e6-f011-8544-7c1e5236b083' data-form-api-url='https://public-eur.mkt.dynamics.com/api/v1.0/orgs/09cc6ce8-e812-41e5-a03e-61c58ebb8054/landingpageforms' data-cached-form-url=  'https://assets-eur.mkt.dynamics.com/09cc6ce8-e812-41e5-a03e-61c58ebb8054/digitalassets/forms/bb4c62ed-40e6-f011-8544-7c1e5236b083'>
                    &nbsp;
                </div>
                <div className="contact-info">
                    Linha de apoio ao cliente através do número 253 009 900 dias úteis entre as 09h00 e as 19h00 (chamada para a rede fixa nacional)
                </div>
            </div>
        );
    }
}
